import { createContext } from 'react';

const LazyContext = createContext({ strict: false });

export { LazyContext };
